import type { DrillDownType } from '@/modules/admin/resources'

export const DrillDownContextActionType = {
  SET_QUERY_YEAR: 'SET_QUERY_YEAR',
  SET_QUERY_PERIOD: 'SET_QUERY_PERIOD',
  SET_QUERY_SEARCH: 'SET_QUERY_SEARCH',
  SET_QUERY_CURRENCY: 'SET_QUERY_CURRENCY',
  SET_QUERY_TYPE: 'SET_QUERY_TYPE',
  SET_QUERY_TYPE_ID: 'SET_QUERY_TYPE_ID',
  SET_PRODUCT_CATEGORY_ID: 'SET_PRODUCT_CATEGORY_ID',
  SET_PRODUCT_GROUP_ID: 'SET_PRODUCT_GROUP_ID',
  SET_PRODUCT_ID: 'SET_PRODUCT_ID',
  SET_DEPARTMENT_ID: 'SET_DEPARTMENT_ID',
  SET_COST_OBJECT_ID: 'SET_COST_OBJECT_ID',
  SET_ENTITY: 'SET_ENTITY',
  SET_CATEGORY: 'SET_CATEGORY',
  SET_GROUP: 'SET_GROUP',
  SET_PRODUCT: 'SET_PRODUCT',
  SET_DEPARTMENT: 'SET_DEPARTMENT',
  SET_COST_OBJECT: 'SET_COST_OBJECT',
  SET_MULTIPLE_DRILL_DOWN: 'SET_MULTIPLE_DRILL_DOWN',
} as const

export type DrillDownContextActionType = typeof DrillDownContextActionType

type SetQueryYearAction = {
  type: DrillDownContextActionType['SET_QUERY_YEAR']
  payload: string
}

type SetQuerySearchAction = {
  type: DrillDownContextActionType['SET_QUERY_SEARCH']
  payload: string
}

type setQueryCurrencyAction = {
  type: DrillDownContextActionType['SET_QUERY_CURRENCY']
  payload: string
}

type SetQueryPeriodAction = {
  type: DrillDownContextActionType['SET_QUERY_PERIOD']
  payload: string
}

type SetQueryTypeAction = {
  type: DrillDownContextActionType['SET_QUERY_TYPE']
  payload: DrillDownType
}

type SetQueryTypeIdAction = {
  type: DrillDownContextActionType['SET_QUERY_TYPE_ID']
  payload: string
}

type SetProductCategoryIdAction = {
  type: DrillDownContextActionType['SET_PRODUCT_CATEGORY_ID']
  payload: string
}

type SetProductGroupIdAction = {
  type: DrillDownContextActionType['SET_PRODUCT_GROUP_ID']
  payload: string
}

type SetProductIdAction = {
  type: DrillDownContextActionType['SET_PRODUCT_ID']
  payload: string
}

type SetDepartmentIdAction = {
  type: DrillDownContextActionType['SET_DEPARTMENT_ID']
  payload: string
}

type SetCostObjectIdAction = {
  type: DrillDownContextActionType['SET_COST_OBJECT_ID']
  payload: string
}

type SetMultipleDrillDownAction = {
  type: DrillDownContextActionType['SET_MULTIPLE_DRILL_DOWN']
  payload: { [K in keyof Partial<DrillDownContextState>]: DrillDownContextState[K] }
}

export type DrillDownContextAction =
  | SetQueryYearAction
  | SetQuerySearchAction
  | setQueryCurrencyAction
  | SetQueryPeriodAction
  | SetQueryTypeAction
  | SetQueryTypeIdAction
  | SetProductCategoryIdAction
  | SetProductGroupIdAction
  | SetProductIdAction
  | SetDepartmentIdAction
  | SetCostObjectIdAction
  | SetMultipleDrillDownAction

export type DrillDownContextState = {
  year: string
  period: string
  search: string
  currency: string
  type: DrillDownType | null
  typeId: string | null
  productCategoryId: string | null
  productGroupId: string | null
  productId: string | null
  departmentId: string | null
  costObjectId: string | null
}
